import { EntityMetadataMap, EntityDataModuleConfig } from '@ngrx/data';
import { AvailableInputTypeV0 } from '../rdsap-api';

// Define the custom entity metadata
// The selectId function is used to select the primary key for the entity
export const entityMetadata: EntityMetadataMap = {
  CustomInputTypes: {
    selectId: (t: AvailableInputTypeV0) => t.id },
  RdSAPLookUpCodes: {
    selectId: () => 'rdSAPLookUpCodes_singleton'
  },
  RdSAPDetails: {
    selectId: () => 'rdSAPDetails_singleton'
  },
  RdSAPInfo: {
    selectId: () => 'rdSAPInfo_singleton'
  },
  RdSAPHealth: {
    selectId: () => 'rdSAPHealth_singleton'
  },
};

// Define the plural names to use for each entity type
const pluralNames = {  };

export const entityConfig: EntityDataModuleConfig = {
  entityMetadata,
  pluralNames
};
